import { render, staticRenderFns } from "./CoreInput.vue?vue&type=template&id=2ec733dc&lang=pug&"
import script from "./CoreInput.vue?vue&type=script&lang=js&"
export * from "./CoreInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports